import { useState, useEffect } from "react";
import { SnackbarProps } from "./SnackbarProps";

export const Snackbar = ({
  message,
  type = "info",
  duration = 3000
}: SnackbarProps) => {

  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), duration - 300);
    const hideTimer = setTimeout(() => setVisible(false), duration);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [message, duration]);

  if (!visible) return null;

  const bgColors: Record<string, string> = {
    success: "bg-green-700",
    error: "bg-red-600",
    info: "bg-blue-600",
    warning: "bg-yellow-500 text-black"
  };

  return (
    <div
      className={`
        fixed bottom-24 left-1/2 -translate-x-1/2
        px-4 py-2 rounded-md text-white shadow-lg
        z-[9999] text-sm sm:text-base
        transition-all duration-300 ease-in-out
        ${bgColors[type]}
        ${fadeOut ? "opacity-0 translate-y-2" : "opacity-100 translate-y-0"}
      `}
    >
      {message}
    </div>
  );
};
